(function () {
  var dataEl = document.getElementById("pcc-hs-data");
  if (!dataEl) return;
  var data = { brands: [], byHandle: {} };
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function pccDDInit(dd, opts) {
    opts = opts || {};
    var trigger = dd.querySelector(".pcc-dd-trigger");
    var list = dd.querySelector(".pcc-dd-list");
    var valueEl = trigger.querySelector(".pcc-dd-value");
    var options = [];
    var activeIndex = -1;

    function refreshOptions() {
      options = Array.prototype.slice.call(list.querySelectorAll(".pcc-dd-option"));
    }
    refreshOptions();

    function highlight(idx) {
      options.forEach(function (o, i) {
        o.classList.toggle("pcc-dd-option--active", i === idx);
      });
      if (idx >= 0 && options[idx]) options[idx].scrollIntoView({ block: "nearest" });
      activeIndex = idx;
    }

    function position() {
      list.style.top = "calc(100% + 6px)";
      list.style.bottom = "auto";
      var triggerRect = trigger.getBoundingClientRect();
      var spaceBelow = window.innerHeight - triggerRect.bottom - 6 - 8;
      list.style.maxHeight = Math.max(120, Math.min(260, spaceBelow)) + "px";
    }

    function getScrollParent(el) {
      var node = el.parentElement;
      while (node && node !== document.body) {
        var style = getComputedStyle(node);
        if (/(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight) {
          return node;
        }
        node = node.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function ensureSpaceBelow() {
      var rect = trigger.getBoundingClientRect();
      var needed = 260 + 14;
      var spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow < needed) {
        var scrollParent = getScrollParent(trigger);
        scrollParent.scrollBy({ top: needed - spaceBelow, behavior: "instant" });
      }
    }

    function open() {
      if (trigger.disabled) return;
      ensureSpaceBelow();
      list.hidden = false;
      trigger.setAttribute("aria-expanded", "true");
      position();
      var selIdx = options.findIndex(function (o) {
        return o.getAttribute("aria-selected") === "true";
      });
      highlight(selIdx >= 0 ? selIdx : 0);
      document.addEventListener("mousedown", onOutside, true);
      document.addEventListener("keydown", onKey, true);
      window.addEventListener("resize", position);
      document.addEventListener("scroll", position, true);
    }

    function close() {
      list.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      document.removeEventListener("mousedown", onOutside, true);
      document.removeEventListener("keydown", onKey, true);
      window.removeEventListener("resize", position);
      document.removeEventListener("scroll", position, true);
    }

    function onOutside(e) {
      if (!dd.contains(e.target)) close();
    }

    function onKey(e) {
      if (e.key === "Escape") {
        close();
        trigger.focus();
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        highlight(Math.min(activeIndex + 1, options.length - 1));
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        highlight(Math.max(activeIndex - 1, 0));
      } else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (options[activeIndex]) selectOption(options[activeIndex]);
      }
    }

    function selectOption(li) {
      options.forEach(function (o) {
        o.setAttribute("aria-selected", o === li ? "true" : "false");
      });
      valueEl.textContent = li.textContent;
      valueEl.classList.remove("pcc-dd-placeholder");
      close();
      if (opts.onSelect) opts.onSelect(li.dataset.value, li.textContent);
    }

    trigger.addEventListener("click", function () {
      if (list.hidden) open();
      else close();
    });

    list.addEventListener("click", function (e) {
      var li = e.target.closest(".pcc-dd-option");
      if (li) selectOption(li);
    });

    return {
      setOptions: function (items, placeholder) {
        list.innerHTML = "";
        items.forEach(function (item) {
          var li = document.createElement("li");
          li.className = "pcc-dd-option";
          li.setAttribute("role", "option");
          li.setAttribute("aria-selected", "false");
          li.dataset.value = item.value;
          li.textContent = item.label;
          list.appendChild(li);
        });
        refreshOptions();
        valueEl.textContent = placeholder;
        valueEl.classList.add("pcc-dd-placeholder");
      },
      setDisabled: function (disabled) {
        trigger.disabled = disabled;
      },
      reset: function (placeholder) {
        valueEl.textContent = placeholder;
        valueEl.classList.add("pcc-dd-placeholder");
        options.forEach(function (o) {
          o.setAttribute("aria-selected", "false");
        });
      }
    };
  }

  var brandDD = pccDDInit(document.getElementById("pcc-hs-brand-dd"), {
    onSelect: function (handle, label) {
      var brand = data.byHandle[handle];
      submitBtn.disabled = true;
      selectedModelUrl = null;
      if (!brand) {
        modelDD.setDisabled(true);
        modelDD.reset("Select brand first");
        return;
      }
      var items = [{ value: brand.collectionUrl, label: "All " + label + " Models" }];
      brand.models.forEach(function (m) {
        items.push({ value: m.url, label: m.title });
      });
      modelDD.setOptions(items, "Select model");
      modelDD.setDisabled(false);
    }
  });

  var selectedModelUrl = null;
  var modelDD = pccDDInit(document.getElementById("pcc-hs-model-dd"), {
    onSelect: function (url) {
      selectedModelUrl = url;
      submitBtn.disabled = false;
    }
  });

  var submitBtn = document.getElementById("pcc-hs-submit");

  brandDD.setOptions(
    data.brands.map(function (b) {
      return { value: b.handle, label: b.title };
    }),
    "Select brand"
  );

  submitBtn.addEventListener("click", function () {
    if (selectedModelUrl) {
      window.location.href = selectedModelUrl;
    }
  });
})();
